import customHeaders, { getSpace } from '../../../common/headers';
import { useParams } from 'react-router-dom';
import { useDataTable } from '../../../common/hooks';
import { useState, useEffect, useRef } from 'react';
import { TableBox, Tabs } from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../../store/general';
import './RequestLogs.scss';
import { TitlePage } from '../../../components/TitlePage/TitlePage';
import { Filters } from '../Filters/Filters';
import { periodWeek } from '../../../common/constant';

const btn_tab = [
  { label: 'По площадкам', value: 'by_date_and_market_name' },
  { label: 'Сводная', value: 'summary' },
];

const RequestLogs = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };

  const [pageValue, setPageValue] = useState('');
  // Фильтры     
  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);

  const [date, setDate] = useState(periodWeek())
  const [isTableRequest, setIsTableRequest] = useState(false);

  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;

  const activeTab = useParams()['*'];

  useEffect(() => {
    setPageValue(activeTab);
  }, [activeTab]);

  return (
    <div className="request-logs">
      <TitlePage
        title='Логи запросов'
      />

      <Filters
        selectedApi={selectedApi}
        setSelectedApi={setSelectedApi}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        isTableRequest={isTableRequest}
        setIsTableRequest={setIsTableRequest}
        date={date}
        setDate={setDate}
      />

      <Tabs
        tabs={btn_tab}
        pageValue={pageValue}
        setPageValue={setPageValue}
      />

      <TableBox
        {...tableProps}
        paginator={true}
        ref={paginatorRef}
      // fetchCallback={fetchTableData}
      />
    </div>
  );
};

export { RequestLogs };
